// ABOUTME: Books coaching through the Nylas slot picker in place of FreeBusy for a participant
// ABOUTME: The caller renders its own trigger; follow-ups run once the modal closes after booking
import { BookingResult } from '@execonline-inc/slot-picker.private';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { ReactNode, useRef, useState } from 'react';
import { currentUserStore } from '../../CurrentUser/Store';
import { Link } from '../../Resource/Types';
import CoachingSchedulerModal from './CoachingSchedulerModal';
import { SchedulerPurpose } from './text';

interface Props {
  schedulerLink: Link;
  // Booking new sessions, or moving one booked session (a reschedule-session link).
  purpose: SchedulerPurpose;
  // Named in the booking outcome; nothing when the page does not have it.
  participantEmail: Maybe<string>;
  // Runs after the modal closes with the sessions booked, so a reload behind it cannot unmount
  // the confirmation.
  onBooked: (booked: BookingResult[]) => void;
  children: (open: () => void) => ReactNode;
}

const CoachingScheduler = ({
  schedulerLink,
  purpose,
  participantEmail,
  onBooked,
  children,
}: Props) => {
  const [open, setOpen] = useState(false);
  const booked = useRef<BookingResult[]>([]);
  const locale = currentUserStore.preferredLanguage.getOrElseValue('en');

  const close = () => {
    setOpen(false);
    if (booked.current.length > 0) {
      onBooked(booked.current);
      booked.current = [];
    }
  };

  return (
    <>
      {children(() => {
        setOpen(true);
      })}
      {open ? (
        <CoachingSchedulerModal
          schedulerHref={schedulerLink.href}
          purpose={purpose}
          participantEmail={participantEmail}
          locale={locale}
          onBooked={(sessions) => {
            // Picking again after a partial booking can book more in the same modal.
            booked.current = [...booked.current, ...sessions];
          }}
          onClose={close}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default observer(CoachingScheduler);
